const enabledFeatureForCompanyEnum = {
    FULL_FLEX_PROGRAM_CREATION: 1,
    DISCOUNT_CREATION: 2,
};

export const IsFullFlexProgramCreationEnabled = companyData => {
    const enabledFeatures = companyData?.meta_data?.enabled_features ?? [];
    return enabledFeatures.includes(
        enabledFeatureForCompanyEnum.FULL_FLEX_PROGRAM_CREATION,
    );
};

export const IsDiscountCreationEnabled = companyData => {
    const enabledFeatures = companyData?.meta_data?.enabled_features ?? [];
    return enabledFeatures.includes(
        enabledFeatureForCompanyEnum.DISCOUNT_CREATION,
    );
};
